import { getSetting } from './settings';
import { authenticatedFetch } from './apiClient';

const PEXELS_API_KEY = process.env.REACT_APP_PEXELS_API_KEY;
const API_URL = process.env.REACT_APP_PROXY_URL || 'http://localhost:3001';

export const getUseAIPhotoFilter = () =>
  getSetting('wanderologie_settings.photoAIFilter');

export async function searchPhotos(query, count = 6) {
  if (!PEXELS_API_KEY || !query) return [];
  try {
    const res = await fetch(
      `https://api.pexels.com/v1/search?query=${encodeURIComponent(query)}&per_page=${count}&orientation=landscape&locale=en-US`,
      { headers: { Authorization: PEXELS_API_KEY } }
    );
    if (!res.ok) return [];
    const data = await res.json();
    return (data.photos || []).map(p => ({ url: p.src.large2x, thumb: p.src.medium, id: p.id, large: p.src.large }));
  } catch {
    return [];
  }
}

export async function searchPhoto(query, fallback = null) {
  if (!PEXELS_API_KEY || !query) return fallback;
  try {
    const res = await fetch(
      `https://api.pexels.com/v1/search?query=${encodeURIComponent(query)}&per_page=5&orientation=landscape&locale=en-US`,
      { headers: { Authorization: PEXELS_API_KEY } }
    );
    if (!res.ok) return fallback;
    const data = await res.json();
    const photos = data.photos || [];
    if (photos.length === 0) return fallback;

    if (getUseAIPhotoFilter()) {
      try {
        const filterRes = await authenticatedFetch(`${API_URL}/api/filter-photos`, {
          method: "POST",
          body: JSON.stringify({
            candidates: photos.map(p => ({ url: p.src.large, id: p.id })),
            activityTitle: query,
          }),
        });
        if (filterRes.ok) {
          const filtered = await filterRes.json();
          return filtered.url || photos[0]?.src?.large2x || fallback;
        }
      } catch {
        // Silent fallback to first result
      }
    }

    return photos[0]?.src?.large2x || fallback;
  } catch {
    return fallback;
  }
}
